import React from 'react';
import { Select, Text, ErrorMsg } from '../element';

const GenericSelect = ({
  multiple = false,
  size = 'medium',
  placeholder = 'Select',
  id,
  value = '',
  label = '',
  options = [],
  onSearch = null,
  onChange,
  onClose,
  children,
  errorMessage = '',
}) => {
  // const onCloseCB = onClose ? onClose : function () {};
  let onCloseCB = function () {
    // empty
  };
  if (onClose) {
    onCloseCB = onClose;
  }
  const LabelBox =
    label.length === 0 ? (
      ''
    ) : (
      <Text id="desc" className="fontSize18 paddingBottom2">
        {label}
      </Text>
    );
  const ErrorMsgBox =
    errorMessage.length === 0 ? null : (
      <ErrorMsg data-test-id={`${id}-error`} className={`errorClassName`}>
        {errorMessage}
      </ErrorMsg>
    );
  const isObjectOptions = options && options.length > 0 && !!options[0].lab;
  return (
    <>
      {LabelBox}
      <Select
        size={size}
        value={value}
        multiple={multiple}
        placeholder={placeholder}
        options={options}
        {...(isObjectOptions && { labelKey: 'lab' })}
        {...(isObjectOptions && { valueKey: { key: 'val', reduce: true } })}
        onSearch={
          onSearch &&
          (searchText => {
            onSearch(searchText);
          })
        }
        onChange={event => onChange(event)}
        onClose={event => onCloseCB(event)}
        data-test-id={`${id}`}>
        {children}
      </Select>
      {ErrorMsgBox}
    </>
  );
};

export default GenericSelect;
